/*
import '@formatjs/intl-relativetimeformat/polyfill';
import '@formatjs/intl-relativetimeformat/dist/locale-data/ja';
import '@formatjs/intl-relativetimeformat/dist/locale-data/en';
*/

const localeList = [
  "ja",
  "en"
];

var localeMessages = {};
for ( var i = 0; i < localeList.length; i ++ ) {
  var locale = localeList[i];
  var common = require("./common/" + locale + ".js").default;
  var custom = require("./" + locale + ".js").default;
  localeMessages[locale] = Object.assign(common, custom);
}

export default localeMessages;
